import React, { useState, useEffect } from 'react';
import './styles/global.css';
import Header from './components/Header/Header';
import Banner from './components/Banner/Banner';
import Overview from './components/Overview/Overview';
import Hero from './components/Hero/Hero';
import AboutSection from './components/AboutSection/AboutSection';
import Partners from './components/Partners/Partners';
import PoweredBy from './components/PoweredBy/PoweredBy';
import LearningPartner from './components/LearningPartner/LearningPartner';
import IITStrip from './components/IITStrip/IITStrip';
import TopRecruiters from './components/TopRecruiters/TopRecruiters';
//import ContactSection from './components/ContactSection/ContactSection';
import ContactInfo from './components/ContactInfo/ContactInfo';
import Gallery from './components/Gallery/Gallery';
import FoundersModal from './components/Founders/FoundersModal';
import FounderMessage from './components/FounderMessage/FounderMessage';
import FloatingCTA from './components/FloatingCTA/FloatingCTA';
import ApplyNowModal from './components/ApplyNow/ApplyNowModal';

const scrollToSection = (id) => {
  const section = document.getElementById(id);
  if (!section) return;
  const header = document.querySelector('.header');
  const headerHeight = header ? header.offsetHeight : 0;
  const top = section.getBoundingClientRect().top + window.scrollY - headerHeight;
  window.scrollTo({ top, behavior: 'smooth' });
};

function App() {
  const [foundersOpen, setFoundersOpen] = useState(false);
  const [applyNowOpen, setApplyNowOpen] = useState(false);
  const [applyInitialQuery, setApplyInitialQuery] = useState('');

  const openApplyNow = (query = '') => {
    setApplyInitialQuery(query);
    setApplyNowOpen(true);
    window.history.pushState(null, '', '/apply');
  };

  const closeApplyNow = () => {
    setApplyNowOpen(false);
    setApplyInitialQuery('');
    window.history.replaceState(null, '', '/');
  };

  useEffect(() => {
    if (window.location.pathname === '/apply') {
      openApplyNow();
      window.history.replaceState(null, '', '/');
    }
  }, []);

  return (
    <div className="app">
      <Header
        onNavigate={scrollToSection}
        onFoundersClick={() => setFoundersOpen(true)}
        onApplyNow={() => openApplyNow()}
      />
      <Banner />
      <IITStrip onApplyNow={openApplyNow} />
      <Overview onApplyNow={openApplyNow} />
      <main>
        <Partners onApplyNow={openApplyNow} />
        <Hero onApplyNow={openApplyNow} />
        <AboutSection />
        <PoweredBy onApplyNow={openApplyNow} />
        <LearningPartner />
        <FounderMessage />
        {/* <ContactSection /> */}
        <Gallery />
        <TopRecruiters />
        <ContactInfo />
      </main>
      {foundersOpen && <FoundersModal onClose={() => setFoundersOpen(false)} />}
      {applyNowOpen && (
        <ApplyNowModal initialQuery={applyInitialQuery} onClose={closeApplyNow} />
      )}
      <FloatingCTA onApplyNow={() => openApplyNow()} />
    </div>
  );
}

export default App;
